import { render } from "./EducationMain.vue?vue&type=template&id=f7cc698a&scoped=true"
import script from "./EducationMain.vue?vue&type=script&lang=js"
export * from "./EducationMain.vue?vue&type=script&lang=js"

import "./EducationMain.vue?vue&type=style&index=0&id=f7cc698a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7cc698a"]])

export default __exports__